
import { Observable } from 'rxjs';

import { IAPIService } from './API-Service/IAPIService';
import { EmailConfirmationModel, HasAlreadyPaidRedirectModel, NotLoggedInReturnModel } from '../Elearning-Models';

export class RouterService {


  
  constructor(private apiService: IAPIService) {

  }
  
  IsLoggedIn(): Observable<NotLoggedInReturnModel>{
      return this.apiService.IsLoggedIn();
  }

  IsEmailConfirmed(): Observable<EmailConfirmationModel>{
    return this.apiService.ConfirmEmailByUser();
  }

  HasAlreadyPaidByStudentConsumerCurrID(sccID: number): Observable<HasAlreadyPaidRedirectModel>{
    return this.apiService.HasAlreadyPaidByStudentConsumerCurrID(sccID);
  }

  HasAlreadyPaidByStudentClassID(studentID: number, classID: number):Observable<HasAlreadyPaidRedirectModel>{
    return this.apiService.HasAlreadyPaidByStudentClassID(studentID, classID);
  }

}
